import Icon from '../components/Icon.vue'

Icon.register({
  tablets: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M160 192c81.1 0 147.5 58.5 160 134.7 0.8 4.8-3.3 9.3-8.3 9.3h-303.3c-5 0-9.1-4.5-8.3-9.3 12.4-76.2 78.8-134.7 159.9-134.7zM311.6 368c5 0 9.1 4.5 8.3 9.3-12.4 76.2-78.8 134.7-159.9 134.7s-147.5-58.5-159.9-134.7c-0.8-4.8 3.3-9.3 8.3-9.3h303.2zM593.4 46.6c56.5 56.5 61.4 144.2 15.9 206.9-2.8 4-8.8 4.3-12.3 0.8l-211.3-211.4c-3.5-3.4-3.2-9.4 0.8-12.3 62.7-45.4 150.4-40.5 206.9 16zM363 65.7l211.3 211.3c3.5 3.4 3.2 9.4-0.8 12.3-62.7 45.5-150.4 40.6-206.9-15.9-56.4-56.5-61.3-144.2-15.9-206.9 2.8-4 8.8-4.3 12.3-0.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tablets.js
// module id = 1979
// module chunks = 0